module.exports = __webpack_public_path__ + "img/p3-1.3ac0112b.png";